// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"8d56f5f22b5852bf8e3c","1125":"3f472209c448191a8eaf","1455":"de5c248c6858f774c765","3635":"e84391a8c4b8dcc4091d","9985":"3942e675b1ee297a18ab"}[chunkId] + ".chunk.js";
};